import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const steps = [
  {
    number: "01",
    title: "Role brief",
    desc: "Define the work, level and outcomes.",
  },
  {
    number: "02",
    title: "Skills evidence",
    desc: "Review assessments and practical proof.",
  },
  {
    number: "03",
    title: "Human context",
    desc: "Understand judgement and communication.",
  },
  {
    number: "04",
    title: "Focused shortlist",
    desc: "Meet relevant people, not a CV pile.",
  },
];

const HomeTalentNetworkSection = () => {
  return (
    <section className="hire-grid-bg text-white py-16 md:py-24 px-4" id="hire">
      <div className="container mx-auto grid home-grid-0885 items-center gap-10 lg:gap-10">
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center font-poppins gap-3 text-secondary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
              <span className="w-8 h-[3px] bg-secondary inline-block"></span>
              Verified talent network
            </p>
            <h2 className="text-white font-poppins font-semibold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-6xl mb-5">
              Meet people through evidence, not profile volume.
            </h2>
            <p className="text-[#d7dfff] font-poppins text-base leading-[1.8] mb-6">
              UtivaHire helps companies move from a clear role brief to a
              focused shortlist with useful context on skills, project evidence
              and communication.
            </p>
            <Link
              to="/hire"
              className="bg-secondary text-primary font-poppins rounded-xl min-h-[50px] px-6 inline-flex items-center gap-3 text-sm font-bold hover:-translate-y-0.5 transition-all"
            >
              Start a Hiring Conversation{" "}
              <span aria-hidden="true">
                <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
              </span>
            </Link>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="border-t border-white/[0.22]">
            {steps.map((step) => (
              <article
                key={step.number}
                className="grid home-grid-step-55 gap-4.5 py-6 border-b border-white/[0.22]"
              >
                <span className="w-10 h-10 font-poppins border border-secondary text-secondary rounded-full grid place-items-center text-sm font-bold">
                  {step.number}
                </span>
                <div>
                  <h3 className="text-lg mb-1.5 font-poppins font-bold">
                    {step.title}
                  </h3>
                  <p className="text-[#d7dfff] font-poppins text-sm leading-[1.65] m-0">
                    {step.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HomeTalentNetworkSection;
